
import React from 'react';
import _ from 'lodash';
import QuillDeltaToHtmlConverter from 'quill-delta-to-html';
import { dp } from '../../../utils/shared.js';

export default (props) => {
  const headlineOps = _.get(props.headline, 'val.ops');
  const headlineOpsInstance = new QuillDeltaToHtmlConverter(headlineOps, {});
  const headlineOpsRichText = headlineOpsInstance.convert();

  const subheadOps = _.get(props.subhead, 'val.ops');
  const subheadOpsInstance = new QuillDeltaToHtmlConverter(subheadOps, {});
  const subheadOpsRichText = subheadOpsInstance.convert();

  const bodyOps = _.get(props.body, 'val.ops');
  const bodyOpsInstance = new QuillDeltaToHtmlConverter(bodyOps, {});
  const bodyOpsRichText = bodyOpsInstance.convert();

  const upperLeftImageSrc = dp(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });

  return (
    <div className="denver-stories__content">
      <div className="denver-stories__story-4">
        <div className="denver-stories__heading ql-editor" dangerouslySetInnerHTML={{ __html: headlineOpsRichText }}></div>
        <div className="denver-stories__centered-col">

          <div className="denver-stories__col">
            <figure className="denver-stories__image-container">
              <div className="denver-stories__image-container-background"></div>
              <div className="denver-stories__image-container-table">
                <div className="denver-stories__image-container-table-cell">
                  <img src={upperLeftImageSrc} alt="" className="denver-stories__image-container-image" />
                </div>
              </div>
              <figcaption className="denver-stories__image-container-caption">
                {props.center_image_caption.val}
              </figcaption>
            </figure>
          </div>
        </div>
       
        <div className="denver-stories__subhead ql-editor" dangerouslySetInnerHTML={{ __html: subheadOpsRichText }}></div>
        <div className="denver-stories__body ql-editor" dangerouslySetInnerHTML={{ __html: bodyOpsRichText }}></div>
       
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverStory4.js